module.exports = __webpack_public_path__ + "fonts/source-code-pro-v22-latin-600.9324b1aa.eot";